/** Đường dẫn endpoint báo thời gian trang hiển thị. */
export const ENGAGEMENT_ENDPOINT = '/dashboard/access-engagement';

/**
 * Ghép URL đầy đủ của endpoint trên từ baseUrl.
 *
 * Tách hẳn ra khỏi hook (và cố tình không đụng React lẫn DOM) để test được: vitest của repo này
 * chạy environment 'node', nên mọi thứ nằm trong useEffect đều không với tới. Trước đây phép ghép
 * này viết inline trong effect nên bản vá cắt "/" thừa bên dưới không có test hồi quy nào canh.
 *
 * baseUrl đến từ cấu hình mount lúc deploy (window.__ENV__.API_URL, xem api/API_App), không kiểm
 * soát được định dạng — nếu có dấu "/" thừa ở cuối sẽ ghép ra "//dashboard/...". apiClient (axios)
 * tự chuẩn hoá dấu gạch đôi khi ghép baseURL, nhưng ở đây tự ghép chuỗi thì không ai chuẩn hoá hộ.
 * Và BE so khớp CHÍNH XÁC đường dẫn cho khách vãng lai (GuestAccessRules chỉ cắt "/" ở cuối, không
 * chuẩn hoá dấu đôi ở giữa) nên "//dashboard/access-engagement" sẽ bị 403 im lặng — request này
 * fire-and-forget lúc rời trang nên không ai thấy lỗi, số liệu chỉ đơn giản là thiếu.
 */
export const buildEngagementUrl = (baseUrl: string): string =>
  `${baseUrl.replace(/\/+$/, '')}${ENGAGEMENT_ENDPOINT}`;
